import { render, staticRenderFns } from "./ed-file-loader.component.vue?vue&type=template&id=033aea51&scoped=true&"
import script from "./ed-file-loader.component.ts?vue&type=script&lang=ts&"
export * from "./ed-file-loader.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-file-loader.component.scss?vue&type=style&index=0&id=033aea51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033aea51",
  null
  
)

export default component.exports